import React from 'react';
import { motion } from 'framer-motion';
const STEPS = [{
  num: '01',
  title: 'Consultation',
  desc: 'Understanding your vision, scale, and specific desires.'
}, {
  num: '02',
  title: 'Planning',
  desc: 'Meticulous logistical preparation and vendor coordination.'
}, {
  num: '03',
  title: 'Design',
  desc: 'Crafting the aesthetic, menu, and atmospheric details.'
}, {
  num: '04',
  title: 'Execution',
  desc: 'Flawless on-site management and premium service.'
}, {
  num: '05',
  title: 'Celebration',
  desc: 'You enjoy the moment; we handle the rest.'
}];
export function EventProcess() {
  return <section className="w-full bg-[#050505] py-20 md:py-32 border-y border-gridline my-10 md:my-20" data-id="element-90">
      <div className="max-w-[95%] lg:max-w-[85%] mx-auto" data-id="element-91">
        <div className="mb-16 md:mb-24 text-center" data-id="element-92">
          <span className="text-accent font-bold uppercase tracking-[0.35em] text-xs" data-id="element-93">
            The Process
          </span>
          <h2 className="mt-4 text-white font-black uppercase tracking-tight text-3xl md:text-5xl" data-id="element-94">
            How We Work
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-4 relative" data-id="element-95">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-[28px] left-[10%] right-[10%] h-px bg-gridline" data-id="element-96" />

          {STEPS.map((step, i) => <motion.div key={step.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="relative flex flex-col items-center text-center group" data-id="element-97">
              <div className="w-14 h-14 rounded-full bg-black border border-white/20 flex items-center justify-center text-accent font-black text-lg mb-6 relative z-10 transition-colors duration-300 group-hover:border-accent group-hover:bg-accent/10" data-id="element-98">
                {step.num}
              </div>
              <h3 className="text-white font-bold uppercase tracking-widest text-sm mb-3" data-id="element-99">
                {step.title}
              </h3>
              <p className="text-white/50 text-xs leading-relaxed max-w-[200px]" data-id="element-100">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}